<div class="mb-3">
    <div>

        <h1 class="pb-2 border-bottom fw-light" i18n>Meldungen</h1>

        <div class="mt-3">
            <app-blog-search-box (searchCriteria)="search($event)"></app-blog-search-box>
        </div>

        <kendo-grid
          [data]="list.gridData"
          [pageable]="true"
          [skip]="list.state.skip"
          [pageSize]="list.state.pageSize"
          [sortable]="true"
          [sort]="list.state.sort"
          (pageChange)="list.onPageChange($event)"
          (sortChange)="list.onSortChange($event)"
          [reorderable]="true"
          [resizable]="true">
            <ng-template kendoGridNoRecordsTemplate>
              <app-grid-no-records [loading]="list.loading" loadingText="Blogbeiträge werden geladen…" i18n-loadingText></app-grid-no-records>
            </ng-template>
            <ng-template kendoGridToolbarTemplate>
                <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
                <button class="btn btn-primary ms-auto" [routerLink]="['/shop-blog-edit']" i18n>Neue Meldung erstellen</button>
            </ng-template>
            <kendo-grid-column field="body" [sortable]="false" i18n-title title="Text" format="{0:g}" [width]="200">
            </kendo-grid-column>
            <kendo-grid-column field="validFrom" format="{0:g}" i18n-title title="Gültig von" [width]="150">
            </kendo-grid-column>
            <kendo-grid-column field="validTo" format="{0:g}" [sortable]="false" i18n-title title="Gültig bis" [width]="150">
            </kendo-grid-column>
            <kendo-grid-column field="isActive" [sortable]="false" i18n-title title="Aktiviert"
                [width]="50">
                <ng-template kendoGridCellTemplate let-dataItem>
                    @if (dataItem.isActive) {
                      <span i18n>ja</span>
                    } @else {
                      <span i18n>nein</span>
                    }
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-command-column i18n-title title="Bearbeiten" [width]="70">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="d-flex justify-content-center gap-2">
                        <button type="button" class="btn btn-sm btn-outline-secondary" title="Bearbeiten" aria-label="Bearbeiten" i18n-title i18n-aria-label (click)="onEdit(dataItem.id)">
                            <i>
                                <fa-icon [icon]="faEdit"></fa-icon>
                            </i>
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-command-column>

            <kendo-grid-pdf appGridPdf fileName="Meldungen.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.7">
              <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
              <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <app-pdf-page title="Meldungen" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
              </ng-template>
            </kendo-grid-pdf>
        </kendo-grid>


    </div>
</div>